import { values } from "lodash";
import { FORM_SCHEMA_TYPES as TYPES } from "../formSchemaTypes";
export const EGYPT_SELECT_VALUES = {
  COUNTRIES_V2: "COUNTRIES_V2",
  EG_MARITAL_STATUS: "EG_MARITAL_STATUS",
  EG_GENDER: "EG_GENDER",
  EG_PASSPORT_TYPE: "EG_PASSPORT_TYPE",
  EG_ENTRY_OPTIONS: "EG_ENTRY_OPTIONS",
  EG_VISA_TYPE: "EG_VISA_TYPE",
  EG_HOST_TYPE: "EG_HOST_TYPE",
  EG_TRIP_PAYER_OPTIONS: "EG_TRIP_PAYER_OPTIONS",
  EG_SECURITY_QUESTIONS: "EG_SECURITY_QUESTIONS",
};

export const egyptSchema = {
  generalInfoSegment: {
    label: "General application information",
    type: TYPES.SEGMENT,
    initialOpen: true,
    data: {
      _id: {
        label: "ID",
      },
      applicantNumber: {
        label: "Applicant number",
        type: TYPES.TEXT,
      },
      siteId: {
        label: "Referral Site",
      },
      orderId: {
        label: "Order ID",
      },
      orderIdHistory: {
        label: "Order ID History",
      },
      invoiceEmail: {
        label: "Payment email",
      },
      zendeskId: {
        label: "Zendesk ID",
        type: TYPES.TEXT,
        required: false,
      },
      userLanguage: {
        label: "User form language",
      },
      userCountry: {
        label: "Users IP country",
      },
      botRuns: {
        label: "Number of bot runs",
      },
      userEmail: {
        label: "User contact email",
        type: TYPES.EMAIL,
      },
      submissionEmail: {
        label: "User submission email",
        type: TYPES.TEXT,
      },
    },
  },
  personal_information: {
    label: "Personal Information",
    type: TYPES.SEGMENT,
    data: {
      userEmail: {
        label: "Email",
        type: TYPES.EMAIL,
        required: true,
      },
      userPhone: {
        label: "Phone number",
        type: TYPES.TEXT,
        required: true,
      },
      firstName: {
        label: "Given name",
        type: TYPES.TEXT,
        required: true,
      },
      lastName: {
        label: "Surname",
        type: TYPES.TEXT,
        required: true,
      },
      birthCountry: {
        label: "Country of birth",
        type: TYPES.SELECT,
        required: true,
        values: EGYPT_SELECT_VALUES.COUNTRIES_V2,
      },
      residenceAddress: {
        label: "Permanent Residence in home country",
        type: TYPES.TEXT,
        required: true,
      },
      birthDate: {
        label: "Date of birth",
        type: TYPES.DATE,
        required: true,
      },
      maritalStatus: {
        label: "Marital status",
        type: TYPES.SELECT,
        required: true,
        values: EGYPT_SELECT_VALUES.EG_MARITAL_STATUS,
      },
      currentOccupation: {
        label: "Profession",
        type: TYPES.TEXT,
        required: true,
      },
      gender: {
        label: "Gender",
        type: TYPES.SELECT,
        required: true,
        values: EGYPT_SELECT_VALUES.EG_GENDER,
      },
    },
  },
  document_information: {
    label: "Document Information",
    type: TYPES.SEGMENT,
    data: {
      passportType: {
        label: "Passport type",
        type: TYPES.SELECT,
        required: true,
        values: EGYPT_SELECT_VALUES.EG_PASSPORT_TYPE,
      },
      passportNumber: {
        label: "Passport number",
        type: TYPES.TEXT,
        required: true,
      },
      passportIssueDate: {
        label: "Date of issue",
        type: TYPES.DATE,
        required: true,
      },
      passportExpiryDate: {
        label: "Expiration date",
        type: TYPES.DATE,
        required: true,
      },
      currentNationality: {
        label: "Current nationality",
        type: TYPES.SELECT,
        required: true,
        values: EGYPT_SELECT_VALUES.COUNTRIES_V2,
      },
      passportIssueCountry: {
        label: "Issued by",
        type: TYPES.SELECT,
        required: true,
        values: EGYPT_SELECT_VALUES.COUNTRIES_V2,
      },
      originalNationality: {
        label: "Original nationality",
        type: TYPES.SELECT,
        required: true,
        values: EGYPT_SELECT_VALUES.COUNTRIES_V2,
      },
      haveOtherNationality: {
        label: "Do you have other nationalities?",
        type: TYPES.BOOLEAN,
      },
      otherNationalities: {
        label: "Other nationalities",
        type: TYPES.MULTI_SELECT,
        dependsOn: "haveOtherNationality",
        values: EGYPT_SELECT_VALUES.COUNTRIES_V2,
      },
      haveDifferentNationalityAtBirth: {
        label: "Have you hold a different nationality at birth?",
        type: TYPES.BOOLEAN,
      },
      nationalityAtBirth: {
        label: "Select country",
        type: TYPES.SELECT,
        dependsOn: "haveDifferentNationalityAtBirth",
        values: EGYPT_SELECT_VALUES.COUNTRIES_V2,
      },
      visitedEgyptBefore: {
        label: "Have you visited Egypt before?",
        type: TYPES.BOOLEAN,
      },
      previousVisitDetails: {
        label: "Previous visit details",
        type: TYPES.NESTED,
        dependsOn: "visitedEgyptBefore",
        newTable: true,
        nested: {
          dateFrom: {
            label: "Date from",
            type: TYPES.DATE,
            path: "previousVisitDetails",
          },
          dateTo: {
            label: "Date to",
            type: TYPES.DATE,
            path: "previousVisitDetails",
          },
          stayPlaceInformation: {
            label: "Where did you stay during this period?",
            type: TYPES.TEXT,
            path: "previousVisitDetails",
          },
        },
      },
      haveBeenDeported: {
        label: "Have you been deported from Egypt or any other country before?",
        type: TYPES.BOOLEAN,
      },
      deportDetails: {
        label: "Deport details",
        type: TYPES.NESTED,
        dependsOn: "haveBeenDeported",
        newTable: true,
        nested: {
          deportationCountry: {
            label: "Select country",
            type: TYPES.SELECT,
            path: "deportDetails",
            values: EGYPT_SELECT_VALUES.COUNTRIES_V2,
          },
          deportationDate: {
            label: "Deportation date",
            type: TYPES.DATE,
            path: "deportDetails",
          },
          deportationReason: {
            label: "Deportation reason",
            type: TYPES.TEXT,
            path: "deportDetails",
          },
        },
      },
    },
  },
  travel_information: {
    label: "Travel Information",
    type: TYPES.SEGMENT,
    data: {
      entryOption: {
        label: "Entry option",
        type: TYPES.SELECT,
        required: true,
        values: EGYPT_SELECT_VALUES.EG_ENTRY_OPTIONS,
      },
      visaType: {
        label: "Visa type",
        type: TYPES.SELECT,
        required: true,
        values: EGYPT_SELECT_VALUES.EG_VISA_TYPE,
      },
      travelingFrom: {
        label: "Traveling from",
        type: TYPES.SELECT,
        required: true,
        values: EGYPT_SELECT_VALUES.COUNTRIES_V2,
      },
      arrivalDate: {
        label: "Intended date of arrival",
        type: TYPES.DATE,
        required: true,
      },
      departureDate: {
        label: "Intended date of departure",
        type: TYPES.DATE,
        required: true,
      },
      host_information: {
        label: "Host information",
        type: TYPES.NESTED,
        newTable: true,
        nested: {
          hostType: {
            label: "Type of host in Egypt",
            type: TYPES.SELECT,
            required: true,
            values: EGYPT_SELECT_VALUES.EG_HOST_TYPE,
          },
          hostName: {
            label: "Host name",
            type: TYPES.TEXT,
            required: true,
          },
          hostPhone: {
            label: "Phone",
            type: TYPES.TEXT,
            required: true,
          },
          hostEmail: {
            label: "Email",
            type: TYPES.EMAIL,
            required: true,
          },
          hostAddress: {
            label: "Address",
            type: TYPES.TEXT,
            required: true,
          },
          tripPayer: {
            label: "Who is paying for your trip?",
            type: TYPES.TEXT,
            required: true,
            values: EGYPT_SELECT_VALUES.EG_TRIP_PAYER_OPTIONS,
          },
        },
      },
    },
  },
  consent_and_declaration: {
    label: "Consent and Declaration",
    type: TYPES.SEGMENT,
    data: {
      securityQuestion: {
        label: "Security question",
        type: TYPES.SELECT,
        values: EGYPT_SELECT_VALUES.EG_SECURITY_QUESTIONS,
      },
      securityAnswer: {
        label: "Security answer",
        type: TYPES.TEXT,
        required: true,
      },
      signatureOfApplicant: {
        label: "Signature of applicant",
        type: TYPES.TEXT,
        required: true,
      },
      consentDeclaration: {
        label: "Consent Declaration",
        type: TYPES.BOOLEAN,
        required: true,
      },
      termsConditions: {
        label: "Terms & Conditions",
        type: TYPES.BOOLEAN,
        required: true,
      },
      parental_consent: {
        label: "Parental Consent (if applicable)",
        type: TYPES.NESTED,
        nested: {
          parentGuardianName: {
            label: "Parent/Guardian Name",
            type: TYPES.TEXT,
          },
          parentGuardianSignature: {
            label: "Signature of parent or guardian",
            type: TYPES.TEXT,
          },
        },
      },
    },
  },
};
